import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { getPasswordStrengthText } from '../../utils/validation';

interface PasswordStrengthIndicatorProps {
  password: string;
  showText?: boolean;
}

export const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> = ({
  password,
  showText = true,
}) => {
  const strength = getPasswordStrengthText(password);
  
  if (!password) return null;

  return (
    <Box sx={{ mt: 1 }}>
      <LinearProgress
        variant="determinate"
        value={(strength.score / 5) * 100}
        sx={{
          height: 4,
          borderRadius: 2,
          backgroundColor: 'grey.300',
          '& .MuiLinearProgress-bar': {
            backgroundColor: strength.color,
            borderRadius: 2,
          },
        }}
      />
      {showText && (
        <Typography
          variant="caption"
          sx={{
            color: strength.color,
            fontWeight: 500,
            display: 'block',
            mt: 0.5,
          }}
        >
          {strength.text}
        </Typography>
      )}
    </Box>
  );
};